export const MAX_MP4_BYTES = 30 * 1024 * 1024
export const VIDEO_UPLOAD_FEATURE = 'video_upload'

const VIDEO_EXTENSION = /\.(mp4|mov|webm|avi|mkv|m4v|mpeg|mpg)$/i

function fileType(file) {
  return String(file?.type || file?.mimetype || '').toLowerCase()
}

function fileName(file) {
  return String(file?.name || file?.originalname || '')
}

export function isMp4File(file) {
  const mime = fileType(file)
  const name = fileName(file).toLowerCase()
  return (
    mime === 'video/mp4' || mime === 'application/mp4' || name.endsWith('.mp4')
  )
}

export function isVideoFile(file) {
  const mime = fileType(file)
  if (mime.startsWith('video/') || mime === 'application/mp4') return true
  return VIDEO_EXTENSION.test(fileName(file))
}

export function exceedsMp4Limit(file) {
  const size = Number(file?.size)
  return isVideoFile(file) && Number.isFinite(size) && size > MAX_MP4_BYTES
}

export function videoUploadAllowed(file, enabled) {
  if (!isVideoFile(file)) return true
  return enabled === true
}
